import AuthStore from './AuthStore';
import { flow, types } from 'mobx-state-tree';
import axios from 'axios';
import { notification } from 'antd';

const RootStore = types
  .model('Rootstore', {
    authStore: types.optional(AuthStore, {}),
  })
  .actions(() => ({
    getToken: () => {
      // Token is now in an HttpOnly cookie; this returns a flag for legacy checks
      return localStorage.getItem('bhaAuthToken');
    },
    post: flow(function* (api, values) {
      try {
        return yield axios.post(api, values);
      } catch (error) {
        notification.error({
          message: error.response?.data?.message || 'Something went wrong',
        });
        return false;
      }
    }),
    get: flow(function* (api) {
      try {
        return yield axios.get(api);
      } catch (error) {
        notification.error({
          message: error.response?.data?.message || 'Something went wrong',
        });
        return false;
      }
    }),
  }));

export default RootStore;
